import { Reducer } from 'redux';
import ActionTypes, { TPrivateChat, TPrivateChatState, TPrivateMessage } from './types';

export const initialState: TPrivateChatState = {
  privateChats: null,
  currentUserId2: null,
  loading: false,
  errors: undefined,
};

const reducer: Reducer<TPrivateChatState> = (state = initialState, action): TPrivateChatState => {
  switch (action.type) {
    case ActionTypes.SET_CURRENT_USER_ID2: {
      const id2 = action.payload as string;
      return {
        ...state,
        currentUserId2: state.privateChats
          ? state.privateChats.find((chat) => {
              if (chat.client.id2 === id2 && id2 === chat.userId1) {
                return chat.isShow2 === 1;
              } else if (chat.client.id2 === id2) {
                return chat.isShow1 === 1;
              }
              return false;
            })?.client.id2 || state.currentUserId2
          : null,
      };
    }

    case ActionTypes.OPEN_PRIVATE_CHAT_R:
    case ActionTypes.GET_PRIVATE_CHATS_R:
    case ActionTypes.SEND_PRIVATE_MESSAGE_R:
    case ActionTypes.CLOSE_PRIVATE_CHAT_R:
      return { ...state, errors: undefined, loading: true };

    case ActionTypes.GET_PRIVATE_CHATS_S: {
      const privateChats = action.payload as TPrivateChat[];
      return {
        ...state,
        privateChats: privateChats,
        currentUserId2: state.currentUserId2 ? state.currentUserId2 : action.payload[0] ? action.payload[0].client.id2 : null,
        loading: false,
      };
    }
    case ActionTypes.CLOSE_PRIVATE_CHAT_S: {
      const privateChat = action.payload as TPrivateChat;
      return {
        ...state,
        privateChats: state.privateChats
          ? state.privateChats.map((chat) => {
              if (
                (chat.roomId === privateChat.roomId && chat.userId1 === privateChat.userId1 && chat.userId2 === privateChat.userId2) ||
                (chat.roomId === privateChat.roomId && chat.userId1 === privateChat.userId2 && chat.userId2 === privateChat.userId1)
              ) {
                return privateChat;
              }
              return chat;
            })
          : [privateChat],
        loading: false,
      };
    }
    case ActionTypes.SET_CREATED_PRIVATE_CHAT:
      return {
        ...state,
        privateChats: state.privateChats ? [...state.privateChats, action.payload] : [action.payload],
        loading: false,
      };
    case ActionTypes.SET_NEW_PRIVATE_MESSAGE:
    case ActionTypes.SEND_PRIVATE_MESSAGE_S: {
      const message = action.payload as TPrivateMessage;
      return {
        ...state,
        privateChats: state.privateChats
          ? state.privateChats.map((chat) => {
              if (
                (chat.roomId === message.roomId && chat.userId1 === message.userId1 && chat.userId2 === message.userId2) ||
                (chat.roomId === message.roomId && chat.userId1 === message.userId2 && chat.userId2 === message.userId1)
              ) {
                return { ...chat, messages: [...chat.messages, message] };
              }
              return chat;
            })
          : null,
        loading: false,
      };
    }
    case ActionTypes.OPEN_PRIVATE_CHAT_S: {
      const privateChat = action.payload as TPrivateChat;
      return {
        ...state,
        privateChats: state.privateChats
          ? [
              ...state.privateChats.filter(
                (chat) => chat.roomId === privateChat.roomId && chat.userId1 === privateChat.userId1 && chat.userId2 === privateChat.userId2
              ),
              privateChat,
            ]
          : [privateChat],
        loading: false,
      };
    }

    case ActionTypes.OPEN_PRIVATE_CHAT_E:
    case ActionTypes.GET_PRIVATE_CHATS_E:
    case ActionTypes.SEND_PRIVATE_MESSAGE_E:
    case ActionTypes.CLOSE_PRIVATE_CHAT_E:
      return { ...state, errors: action.payload, loading: false };
    default:
      return state;
  }
};

export { reducer as PrivateChatReducer };
